import React, { createContext, useEffect, useState, useContext, ReactNode } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../assets/api/endpoints';

// Define the context type

type AuthConfig = {
	action: string;
	enabled: boolean;
	version: 'V2' | 'V3';
};
interface AuthConfigContextType {
	CaptchaConfigs: AuthConfig[] | [];
}
// Create context with a default undefined value
const AuthConfigurationsContext = createContext<AuthConfigContextType | undefined>(undefined);

export const AuthConfigurations: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [CaptchaConfigs, setCaptchaConfigs] = useState<AuthConfig[] | []>([]);

	useEffect(() => {
		const fetcCaptchaConfig = async () => {
			try {
				const response = await axios.get(API_ENDPOINTS.getRecaptchaConfig);
				setCaptchaConfigs(response.data);
			} catch (error) {
				console.error('Failed to fetch holiday status', error);
			}
		};
		fetcCaptchaConfig();
	}, []);

	return <AuthConfigurationsContext.Provider value={{ CaptchaConfigs }}>{children}</AuthConfigurationsContext.Provider>;
};

// Custom hook to expose the holiday context
export const useAuthConfigs = (): AuthConfigContextType => {
	const context = useContext(AuthConfigurationsContext);
	if (!context) {
		throw new Error('useCaptchaConfigs must be used within a CaptchaConfigsProvider');
	}
	return context;
};
